function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _document_documentElement_classList;
var _document_querySelector, _document_querySelectorAll;
import './components/smooth-scroll';
import './components/hover-media';
import './components/inputmask';
import './components/tooltip';
import Dropdown from './components/dropdown';
import Modal from './components/modal';
import Validation from './components/validation';
import './components/inputmask';
import './components/animation';
import './components/gravity-field';
import { device } from './helpers';
import $ from 'jquery';
import Cookies from 'js-cookie';
import parking from './components/parking';
/* SETUP
-------------------------------------------------- */ window.modal = new Modal();
var validation = new Validation();
/* HTML CLASSNAMES
-------------------------------------------------- */ var htmlClassNames = [];
if (device.isMobile()) htmlClassNames.push('-device-mobile');
if (device.isTouch()) htmlClassNames.push('-device-touch');
if (device.isAndroid()) htmlClassNames.push('-device-android');
if (device.isIOS()) htmlClassNames.push('-device-ios');
if (device.isIPhone()) htmlClassNames.push('-device-iphone');
if (device.isIPad()) htmlClassNames.push('-device-ipad');
(_document_documentElement_classList = document.documentElement.classList).add.apply(_document_documentElement_classList, _to_consumable_array(htmlClassNames));
/* DROPDOWN
-------------------------------------------------- */ window.dropdown = new Dropdown();
window.dropdown.init();
/* MENU AND ANCHORS
-------------------------------------------------- */ var menuOpen = false;
var navChange = function() {
    document.body.classList.toggle('-menu-open', menuOpen);
    if (menuOpen) {
        window.lenis.stop();
    } else {
        window.lenis.start();
    }
};
(_document_querySelector = document.querySelector('[data-menu-toggle]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.addEventListener('click', function(event) {
    event.preventDefault();
    menuOpen = !menuOpen;
    navChange();
});
(_document_querySelectorAll = document.querySelectorAll('[data-anchor]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($item) {
    $item.addEventListener('click', function(event) {
        var id = $item.getAttribute('href');
        if (document.getElementById(id.substring(1))) {
            event.preventDefault();
            var timeoutDuration = 0;
            if (menuOpen) {
                menuOpen = false;
                navChange();
                timeoutDuration = 500;
            }
            var timeout = setTimeout(function() {
                // window.lenis.scrollTo(id, {
                // 	duration: 3,
                // 	lock: true
                // })
                document.getElementById(id.substring(1)).scrollIntoView({
                    behavior: 'smooth'
                });
                clearTimeout(timeout);
            }, timeoutDuration);
        }
    });
});
export var name = 'fav';
export var getIds = function() {
    if (!Cookies.get(name)) return [];
    return JSON.parse(Cookies.get(name));
};
var setId = function(id) {
    var ids = getIds();
    var value = id ? _to_consumable_array(ids).concat([
        id
    ]) : ids;
    Cookies.set(name, JSON.stringify(value), {
        path: '/'
    });
};
var removeId = function(id) {
    var ids = getIds();
    var value = id ? ids.filter(function(el) {
        return el !== id;
    }) : [];
    Cookies.set(name, JSON.stringify(value), {
        path: '/'
    });
};
function toggleFav() {
    $('body').delegate('.fav-icon', 'click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var ids = getIds();
        if (ids.length) {
            $('.header__fav').addClass('visible');
            $('.menu__fav').addClass('visible');
        }
        var id = $(this).data('id');
        if (ids.includes(+id)) {
            removeId(id);
        } else {
            setId(id);
            if (typeof window.sendEvent !== 'undefined') {
                var flat = document.querySelector('.room');
                if (flat) {
                    var flatID = flat.getAttribute('data-flat-id');
                    window.sendEvent({
                        name: 'Add to Wishlist',
                        properties: {
                            eventType: 'add-to-wishlist-v1',
                            productId: flatID
                        }
                    });
                }
            }
        }
        $(this).toggleClass('fav-active');
        ids = getIds();
        if (ids.length) {
            $('.header__fav').addClass('visible');
            $('.menu__fav').addClass('visible');
        } else {
            $('.header__fav').removeClass('visible');
            $('.menu__fav').removeClass('visible');
        }
    });
}
if (getIds().length) {
    $('.header__fav').addClass('visible');
    $('.menu__fav').addClass('visible');
} else {
    $('.header__fav').removeClass('visible');
    $('.menu__fav').removeClass('visible');
}
toggleFav();
parking();
